var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
/**
 * example: input fields does not calculate dir on placeholders so we need to render a hidden div and then get direction
 * why: A user might have a default rtl browser language but the form might be in an ltr language so we cannot set direction based on language and must calculate it
 * when dir="auto" does not work
 */
export var useGetComputedDirection = function (placeholder, value) {
    var placeholderRef = useRef();
    var valueRef = useRef();
    var _a = useState('auto'), dir = _a[0], setDir = _a[1];
    useEffect(function () {
        var renderedPlaceholderDirection = window.getComputedStyle(placeholderRef.current, null).direction;
        var renderedValueDirection = window.getComputedStyle(valueRef.current, null).direction;
        if (value !== '' && renderedValueDirection !== 'rtl') {
            setDir('auto');
        }
        else if (renderedValueDirection === 'rtl' ||
            renderedPlaceholderDirection === 'rtl') {
            setDir('rtl');
        }
        else {
            setDir('auto');
        }
    }, [placeholder, value]);
    return [
        dir,
        _jsxs(React.Fragment, { children: [_jsx("div", __assign({ dir: "auto", ref: placeholderRef, style: { display: 'none' } }, { children: placeholder }), void 0), _jsx("div", __assign({ dir: "auto", ref: valueRef, style: { display: 'none' } }, { children: value }), void 0)] }, "use-direction"),
    ];
};
